export default __webpack_public_path__ + "static/media/6t.99af8711.jpg";